export const sidebarCssClasses = [
  'sidebar-show',
  'sidebar-sm-show',
  'sidebar-md-show',
  'sidebar-lg-show',
  'sidebar-xl-show',
]

export const asideMenuCssClasses = [
  'aside-menu-show',
  'aside-menu-sm-show',
  'aside-menu-md-show',
  'aside-menu-lg-show',
  'aside-menu-xl-show',
]

export const validBreakpoints = ['sm', 'md', 'lg', 'xl']

export function checkBreakpoint(breakpoint, list) {
  return list.indexOf(breakpoint) > -1
}

export function toggleClasses(toggleClass, classList, force) {
  // const level = classList.indexOf(toggleClass)
  // const removeClassList = classList.slice(0, level)
  // removeClassList.map((className) => document.body.classList.remove(className))
  document.body.classList.toggle(toggleClass, force)
}

export default function toggle(force) {
  let display = 'lg'
  toggleClasses(asideMenuCssClasses[0], asideMenuCssClasses, force)
  toggleClasses(`aside-menu-${display}-show`, asideMenuCssClasses, force)
}
